import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import request from '../../../utils/request';
import Locked from './Locked';

import actions, { salesRepActions, salesSupportActions } from './utils/getActions';

const Actions = ({ order, status, fetchOrders }) => {
  const { isLockedBy } = order;
  const { email, role_id: role } = request.getProfile();

  const isSalesRep = role === 2;
  const isSalesSupport = role === 11;
  const isAdmin = role === 1;
  const isSalesManager = role === 7;

  let selectedAction = []
  if (isSalesRep || isAdmin) {
      selectedAction = salesRepActions
  }else if(isSalesSupport || isAdmin || isSalesManager){
    selectedAction = salesSupportActions
  }

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      {isLockedBy && isLockedBy !== email ? (
        <Locked />
      ) : (
        _.get(selectedAction, status, []).map(Action => (
          <Action status={status} orderData={order} fetchOrders={fetchOrders} />
        ))
      )}
    </div>
  );
};

Actions.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Actions;
